export default class Mode {
  constructor(id, name = null) {
    this.id = id
    this.name = Translator.trans(`purchase_order.material.modes.${name || id}`)
  }
}
